import { STATISTICS_LIST_COLUMN_LABELS } from '@/constants/statistics/statistics-list-column-labels.constant';
import { StatisticsListColumnProperties } from '@/models/statistics/statistics-list-column-properties.model';
import { StatisticsListItem } from '@/models/statistics/statistics-list.model';
import TableColumn from 'element-plus/lib/components/table/src/tableColumn';

/** @deprecated Use TableColumn from '@/models/app-common.model' instead */
export const STATISTICS_LIST_COLUMN_LIST: Partial<typeof TableColumn> = [
  {
    prop: StatisticsListColumnProperties.SECTION,
    label: STATISTICS_LIST_COLUMN_LABELS.section,
    width: 80,
    cellClass: (row: StatisticsListItem): string => 'statistics-list__cell_capitalize',
  },
  {
    prop: StatisticsListColumnProperties.REGISTRATION_COUNT,
    label: STATISTICS_LIST_COLUMN_LABELS.registrationCount,
    cellClass: (row: StatisticsListItem): string => 'statistics-list__cell_primary',
    width: 80,
  },
  {
    prop: StatisticsListColumnProperties.FIRST_DEPOSIT_COUNT,
    label: STATISTICS_LIST_COLUMN_LABELS.firstDepositCount,
    width: 80,
  },
  {
    prop: StatisticsListColumnProperties.ACTIVE_PLAYER_COUNT,
    label: STATISTICS_LIST_COLUMN_LABELS.activePlayerCount,
  },
  {
    prop: StatisticsListColumnProperties.DEPOSIT_SUM,
    label: STATISTICS_LIST_COLUMN_LABELS.depositSum,
    formatter: (row: StatisticsListItem): string => `€ ${row[StatisticsListColumnProperties.DEPOSIT_SUM]}`,
  },
  {
    prop: StatisticsListColumnProperties.CASHOUT_SUM,
    label: STATISTICS_LIST_COLUMN_LABELS.cashoutSum,
    formatter: (row: StatisticsListItem): string => `€ ${row[StatisticsListColumnProperties.CASHOUT_SUM]}`,
  },
  {
    prop: StatisticsListColumnProperties.BET_SUM,
    label: STATISTICS_LIST_COLUMN_LABELS.betSum,
  },
  {
    prop: StatisticsListColumnProperties.WIN_SUM,
    label: STATISTICS_LIST_COLUMN_LABELS.winSum,
  },
  {
    prop: StatisticsListColumnProperties.GGR,
    label: STATISTICS_LIST_COLUMN_LABELS.ggr,
    hintKey: (row: StatisticsListItem): string => `${row[StatisticsListColumnProperties.SECTION]}Ggr`,
    formatter: (row: StatisticsListItem): string => `€ ${row[StatisticsListColumnProperties.GGR]}`,
    cellClass: (row: StatisticsListItem): string =>
      Number(row[StatisticsListColumnProperties.GGR]) < 0
        ? 'statistics-list__cell_danger'
        : 'statistics-list__cell_success',
  },
  {
    prop: StatisticsListColumnProperties.NGR,
    label: STATISTICS_LIST_COLUMN_LABELS.ngr,
    hintKey: (row: StatisticsListItem): string => `${row[StatisticsListColumnProperties.SECTION]}Ngr`,
    formatter: (row: StatisticsListItem): string => `€ ${row[StatisticsListColumnProperties.NGR]}`,
    cellClass: (row: StatisticsListItem): string =>
      Number(row[StatisticsListColumnProperties.NGR]) < 0
        ? 'statistics-list__cell_danger'
        : 'statistics-list__cell_success',
  },
  {
    prop: StatisticsListColumnProperties.RTP,
    label: STATISTICS_LIST_COLUMN_LABELS.rtp,
    hintKey: (row: StatisticsListItem): string => `${row[StatisticsListColumnProperties.SECTION]}Rtp`,
    formatter: (row: StatisticsListItem): string => `${row[StatisticsListColumnProperties.RTP]} %`,
    cellClass: (row: StatisticsListItem): string => 'statistics-list__cell_warning',
  },
];
